export const harnessTranslations = {
  en: {
    hero: {
      badge: 'Wire Harness Industry Specialists',
      title: 'Specialized fixtures, holders, and devices for wire harness assembly and testing.',
      subtitle: 'Custom-designed solutions for assembly and testing processes for low and high-volume production environments.',
      cta1: 'Request a Quote',
      cta2: 'Submit Technical Requirements',
      trust1: 'Dynalab certified',
      trust2: 'Custom tooling',
      trust3: 'Fast delivery'
    },
    assembly: {
      title: 'Assembly',
      titleAccent: 'Solutions',
      items: [
        'Assembly fixtures',
        'Routing and positioning holders',
        'Pneumatic and manual devices',
        'Counter-tools and custom tooling',
        'Precision guides, supports, and mechanical elements',
        'Custom connector adapters and interface parts'
      ],
      note: 'Designed for ergonomics, repeatability, and long-term durability in production environments.'
    },
    testing: {
      title: 'Testing',
      titleAccent: 'Solutions',
      items: [
        'Electrical test fixtures',
        'Authorized Dynalab system integrator',
        'Leak Test solutions for connector and component sealing validation',
        'Mechanical and pneumatic devices for functional testing',
        'Terminal position, mounting verification fixtures Push back/Pull System',
        'Test benches and fixtures for Data Center Power Harness Applications'
      ],
      note: 'Built for high-repeatability environments with frequent engineering changes.'
    },
    engineering: {
      title: 'Engineering &',
      titleAccent: 'NPI(APQP - PPAP) Support',
      items: [
        'Connector prototypes and custom adapters',
        'NPI and pre-series tooling development',
        'Fast implementation of engineering changes (ECN/ECO)',
        'In-house CNC machining + electrical integration',
        'Clear documentation aligned with automotive industry practices'
      ]
    },
    advantages: {
      title: 'Why Choose',
      titleAccent: 'DSI',
      items: [
        'Specialized Dynalab integrators',
        'Mechanical + CNC + electrical integration in one facility',
        'Short and reliable lead times',
        'Fully customized tooling',
        'Experience with global wire harness manufacturers',
        'Designed for ergonomics, precision, and high durability',
        'Ongoing technical support'
      ]
    },
    midCta: {
      title: 'Need a custom fixture or holder?',
      button1: 'Request a Quote',
      button2: 'Submit Requirements'
    },
    gallery: {
      title: 'Examples of',
      titleAccent: 'Fixtures and Tooling',
      images: [
        {
          title: 'Custom Assembly Fixture',
          caption: 'Precision assembly fixture for automotive harness - Ergonomic design - Dynalab certified'
        },
        {
          title: 'Electrical Test Station',
          caption: 'High-repeatability test fixture - Integrated Dynalab system - Connector validation'
        },
        {
          title: 'Positioning Holder System',
          caption: 'Routing and positioning tooling - Manual or Pneumatic operation - Fast changeover design'
        }
      ]
    },
    finalCta: {
      title: 'Ready to support your harness assembly and',
      titleAccent: 'testing operations?',
      button1: 'Request a Quote',
      button2: 'Contact DSI'
    }
  },
  es: {
    hero: {
      badge: 'Especialistas en Industria Arnesera',
      title: 'Fixtures, holders y dispositivos especializados para ensamble y prueba de arneses.',
      subtitle: 'Diseño y fabricación de soluciones de prueba eléctrica y ensamble para producción de bajo y alto volumen.',
      cta1: 'Solicitar cotización',
      cta2: 'Enviar requerimiento técnico',
      trust1: 'Certificado Dynalab',
      trust2: 'Herramental a medida',
      trust3: 'Entrega rápida'
    },
    assembly: {
      title: 'Soluciones para',
      titleAccent: 'ensamble de arneses',
      items: [
        'Fixtures de ensamble',
        'Holders para ruteo, sujeción y posicionamiento',
        'Dispositivos neumáticos y manuales',
        'Contras y herramentales especiales',
        'Soportes, guías y elementos de precisión',
        'Adaptadores y piezas personalizadas para conectores'
      ],
      note: 'Diseñados para ergonomía, repetibilidad y alta durabilidad en piso de producción.'
    },
    testing: {
      title: 'Soluciones para',
      titleAccent: 'prueba de arneses y conectores',
      items: [
        'Fixtures para pruebas eléctricas',
        'Integración especializada y autorizada de Dynalab',
        'Pruebas de fugas (Leak Test) para validar hermeticidad de conectores y componentes',
        'Dispositivos mecánicos y neumáticos para pruebas funcionales',
        'Integración de fixturas para verificación de correcta inserción de terminales, Push back/Pull System',
        'Fixturas y bancos de prueba electrica/HV (Hi-Pot) para aplicaciones de datacenters'
      ],
      note: 'Soluciones desarrolladas para ambientes de alta repetitividad y cambios frecuentes de ingeniería.'
    },
    engineering: {
      title: 'Soporte a',
      titleAccent: 'ingeniería y NPI(APQP - PPAP)',
      items: [
        'Prototipos de conectores y adaptadores',
        'Desarrollo para NPI y pre-series',
        'Implementación rápida de cambios de ingeniería (ECN/ECO)',
        'Diseño y manufactura interna en CNC y ensamble eléctrico',
        'Documentación técnica clara y compatible con procesos automotrices'
      ]
    },
    advantages: {
      title: 'Ventajas',
      titleAccent: 'competitivas',
      items: [
        'Integradores especializados Dynalab',
        'Diseño + CNC + integración eléctrica en una sola empresa',
        'Tiempos de entrega cortos y flexibles',
        'Soluciones 100% personalizadas',
        'Experiencia con fabricantes globales de arneses',
        'Enfoque en ergonomía, repetibilidad y durabilidad',
        'Soporte técnico continuo'
      ]
    },
    midCta: {
      title: '¿Necesitas un fixture o dispositivo a medida?',
      button1: 'Cotizar ahora',
      button2: 'Enviar requerimiento'
    },
    gallery: {
      title: 'Ejemplos de',
      titleAccent: 'fixtures y holders fabricados',
      images: [
        {
          title: 'Fixture de Ensamble Personalizado',
          caption: 'Fixture de ensamble de precisión para arneses automotrices - Diseño ergonómico - Certificado Dynalab'
        },
        {
          title: 'Estación de Prueba Eléctrica',
          caption: 'Fixture de prueba de alta repetibilidad - Sistema Dynalab integrado - Validación de conectores'
        },
        {
          title: 'Sistema de Holder de Posicionamiento',
          caption: 'Herramental de ruteo y posicionamiento - Operación neumática o manual - Diseño de cambio rápido'
        }
      ]
    },
    finalCta: {
      title: 'Listos para apoyar tu operación de',
      titleAccent: 'ensamble y prueba',
      button1: 'Solicitar cotización',
      button2: 'Contactar a DSI'
    }
  }
};